/**
 * Checks if a path matches a pattern with $ placeholders
 * @param {string} path - The actual path to check
 * @param {string} pattern - The pattern to match against (e.g., 'clients/$')
 * @returns {boolean} - True if the path matches the pattern
 */
const matchesPattern = (path, pattern) => {
  // Convert pattern to regex: clients/$ becomes ^clients/[^/]+$
  const regexPattern = '^' + pattern.replace(/\$/g, '[^/]+') + '$';
  return new RegExp(regexPattern).test(path);
};

/**
 * Gets the value from an object using pattern matching
 * Supports patterns like 'clients/$' where $ represents an entity ID
 * 
 * @param {string} path - The actual path to match (e.g., 'clients/2fzyie868tovn7bc')
 * @param {Object} patternObject - Object with pattern keys to match against
 * @returns {*} - The value associated with the matching pattern or undefined
 */
const getValueByPatternMatch = (path, patternObject) => {
  // First try exact match
  if (patternObject[path]) {
    return patternObject[path];
  }
  
  // Then try pattern matching
  const patterns = Object.keys(patternObject);
  const matchingPattern = patterns.find((pattern) => pattern.includes('$') && matchesPattern(path, pattern));
  
  return matchingPattern ? patternObject[matchingPattern] : undefined;
};

module.exports = { getValueByPatternMatch }; 
